import { render } from "./CxOverlayControlsGroup.vue?vue&type=template&id=88d75ad0"
import script from "./CxOverlayControlsGroup.vue?vue&type=script&lang=js"
export * from "./CxOverlayControlsGroup.vue?vue&type=script&lang=js"

import "./CxOverlayControlsGroup.vue?vue&type=style&index=0&id=88d75ad0&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__